import { effect } from "./Effect.js";
import { track, untrack } from "./tracking.js";
export function watch(host, observable) {
    if (!observable) {
        return (observable) => {
            return watch(host, observable);
        };
    }
    return effect(host, () => {
        track(host, observable);
        return () => untrack(host, observable);
    });
}
